import React, { useEffect, useState } from 'react';
import CaseTicketService from './CaseTicketService';

const baht = (n) => Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// The ตามของ weight-fee discount on an order, as the backend applies it: the fee
// typed or calculated is always the FULL fee, the discount comes off on save.
// `status` = one row of GET /api/case-ticket/weight-assist.
// `hideCase`: on the case's own page "(เคส #…)" says nothing.
export const WeightAssistTag = ({ status, showHint = false, hideCase = false }) => {
  if (!status) return null;
  const what = status.percent >= 100 ? 'ฟรีค่าน้ำหนัก' : `ลดค่าน้ำหนัก ${status.percent}%`;
  const caseRef = hideCase ? '' : `(เคส #${status.caseId})`;
  if (status.paidBeforeDiscount) {
    return (
      <div className="text-xs text-red-700 font-medium">
        ⚠️ {what} {caseRef} — ชำระแล้ว {status.refundQuoted
          ? `คืนส่วนต่าง ฿${baht(status.refundDue)} (สร้างรายการคืนเงินเมื่อกด ✓ แจ้งลูกค้าแล้ว)`
          : `ต้องคืนส่วนต่าง ฿${baht(status.refundDue)} (ทำที่หน้าโอนเงินคืน)`}
      </div>
    );
  }
  if (status.refundedDifference > 0) {
    return (
      <div className="text-xs text-emerald-700">
        ชำระเต็มแล้ว — คืนส่วนต่าง ฿{baht(status.refundedDifference)} แล้ว · {what} {caseRef}
      </div>
    );
  }
  return (
    <div className="text-xs text-emerald-700">
      {status.appliedAt
        ? <>{baht(status.originalFee)} → {status.percent >= 100 ? 'ชำระแล้ว (ฟรี)' : baht(status.newFee)} · {what} {caseRef}</>
        : <>{what} {caseRef} — หักให้อัตโนมัติเมื่อใส่ค่าน้ำหนัก</>}
      {showHint && <div className="text-gray-500">กรอกราคาเต็ม ระบบหักส่วนลดให้เอง</div>}
    </div>
  );
};

/** orderId → discount status, for the orders on screen (refetched when the list or `version` changes). */
export const useWeightAssists = (orderIds = [], version = 0) => {
  const [byOrder, setByOrder] = useState({});
  const key = [...new Set(orderIds.filter(Boolean))].sort((a, b) => a - b).join(',');
  useEffect(() => {
    if (!key) { setByOrder({}); return; }
    CaseTicketService.getWeightAssists(key)
      .then((res) => setByOrder(Object.fromEntries((res.data || []).map((s) => [s.orderId, s]))))
      .catch(() => setByOrder({}));
  }, [key, version]);
  return byOrder;
};
